import { render, staticRenderFns } from "./SwapData.vue?vue&type=template&id=0f0c1410"
import script from "./SwapData.vue?vue&type=script&lang=js"
export * from "./SwapData.vue?vue&type=script&lang=js"
import style0 from "./SwapData.vue?vue&type=style&index=0&id=0f0c1410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports